module.exports = __webpack_public_path__ + "img/icon-photo.b5e158fe.svg";